/**
 * Flattens a block output / add_indicator row into parent (+ optional chevron children)
 * for the dimensional data table (matches FetchBlockOutputsV2 Redux shape).
 */
export default function flattenIndicatorOutputsForTable(object: Record<string, any>): any[] {
  const flattened: any[] = [];

  if (object?.dim_item_data) {
    flattened.push({ ...object, chevronType: 'parent' });
  } else {
    flattened.push(object);
  }

  if (!object?.dim_item_data) return flattened;

  const dimItems = Array.isArray(object.dim_item_data)
    ? object.dim_item_data
    : Object.values(object.dim_item_data || {});

  dimItems.forEach((dataObject: any, index: number) => {
    flattened.push({
      ...dataObject,
      id: dataObject?.id ?? `${object?.id ?? 'parent'}__${dataObject?.name ?? index}`,
      type: object?.type,
      chevronType: 'child',
      total_values: dataObject?.value ?? dataObject?.total_values,
      indicatorId: object?.id,
      parentId: object?.id,
    });
  });

  return flattened;
}
